module.exports = __webpack_public_path__ + "media/images/pages/blumhouses_logos-04fb696fb5c06f840c83ca499ef3c03c.png";